export const demoEstimateData = {
  company: {
    appsettings: {
      customerPreviewFontSize: 12,
      pdfFontSize: 8,
    },
    address: {
      addLine1: 'Golden Gateway Wyecroft Plaza',
      addLine2: 'Main St 2',
      city: 'Oakville',
      state: 'Missouri',
      stateCode: 'MO',
      zip: 'ON L6L 6M1',
      country: 'Canada',
    },
    name: 'Autoleap',
    email: 'sales@autoleap.com',
    phone: '8555600088',
    phone2: '8555600088',
    logo: '../../assets/autoleap-logo.png',
    website: 'https://autoleap.com/',
  },
  estimate: {
    serviceWriter: {
      serviceWriterId: '5f75e92a1d8dd0001760ebd9',
      name: 'Autoleap user',
    },
    totalCost: { part: 92.23, labor: 2220, tire: 0, hazmatFee: 0, other: 0 },
    workFlowStatus: {
      name: 'Estimate',
    },
    customer: {
      isFleetCustomer: false,
      companyName: '',
      isEmail: true,
      isSMS: false,
      customerId: {
        address: {
          addLine1: '',
          addLine2: '',
          city: '',
          state: '',
          zip: '',
          country: '',
          stateCode: '',
        },
        firstName: 'Jane',
        lastName: 'Doe',
        email: 'janedoe@autoleap.com',
        phone: '',
      },
      phone: '',
      notes: '',
      displayName: 'Jane Doe',
      email: 'janedoe@autoleap.com',
      fullName: 'Jane Doe',
      tags: [],
    },
    vehicle: {
      vehicleId: {
        _id: '612dba2b5aaf103ee019691c',
        year: 2020,
        make: 'Mercedes-Benz',
        ODM: [],
        model: 'GLC300 Base',
        engine: '2.0L L4 (274.920) Turbocharged GAS FI',
      },
      name: '2020 Mercedes-Benz GLC300 Base',
    },
    total: {
      discount: { value: 0, cap: 0, type: 'percentage', name: 'Percent' },
      shopSupplyFee: { value: 20, cap: 100, type: 'percentage' },
      tax: {
        value: 9,
        cap: 0,
        type: 'percentage',
        qboId: '5',
        name: 'HST ON - 9%',
      },
      itemTypeDiscount: {
        part: 0,
        labor: 0,
        tire: 0,
        hazmatFee: 0,
        other: 0,
      },
      parts: 93.1,
      labor: 1660,
      tire: 0,
      other: 0,
      hazmatFee: 0,
      total: 1753.1,
      netTotal: 0,
      shopFee: 100,
      shopFeePercent: '5.7',
      afterDiscount: 1853.1,
      afterTax: 1862.1,
      grand: 1862.1,
      paid: 0,
      unpaid: 1862.1,
      discountedAmount: 0,
      taxedAmount: 9,
      nonTaxableAmount: 1753.1,
      taxableAmount: 100,
      itemDiscountedAmount: 0,
    },
    taxValues: {
      parts: true,
      labor: true,
      tire: true,
      other: true,
      hazmatFee: true,
      preDiscountTax: false,
      taxRates: [
        {
          taxAmount: 3,
          _id: '612c9f0cedd0f90017f57139',
          taxId: '612771f3ad6ebb56ccd69092',
          name: 'Tax rate 0003',
          salesTaxRate: 3,
        },
        {
          taxAmount: 5,
          _id: '612c9f14edd0f90017f57147',
          taxId: '612771e6ad6ebb56ccd69091',
          name: 'Tax rate 002',
          salesTaxRate: 5,
        },
        {
          taxAmount: 1,
          _id: '612c9f1aedd0f90017f57156',
          taxId: '612771dcad6ebb56ccd69090',
          name: 'Tax rate 001',
          salesTaxRate: 1,
        },
      ],
    },
    priority: {
      priorityId: '6107d57f708c9045f4aad164',
      name: 'Medium lol lol lol lol',
      color: '#00c19d',
      order: 300,
    },
    vehicleMileage: { reading: null, mileageMeasuringUnit: '' },
    adjustments: {
      actualDiscount: { value: 0, cap: 0, type: 'percentage' },
      actualShopSupplies: { value: 0, cap: 0, type: 'percentage' },
      isApplied: false,
    },
    type: 'yy',
    isOrderPlaced: false,
    isQuickbooksCalCompatibiltyOn: true,
    roundOffTax: true,
    isShopFeeEnabled: true,
    carfaxReportingEnabled: false,
    carfaxReportSent: false,
    isSyncedWithPartsTech: true,
    title: 'Maintenance',
    authorized: true,
    firstOrder: false,
    authByCustomer: false,
    isSyncedWithQBO: false,
    billableHours: 8.299999999999999,
    workedHours: 0,
    displayServiceWriter: false,
    orderStatus: 'estimate',
    invoiced: false,
    saleStatus: 'inprogress',
    isPickupScheduled: false,
    isPaidFull: false,
    isPaidPartial: false,
    isArchived: false,
    cash: 0,
    cheque: 0,
    card: 0,
    creditPayment: 0,
    thirdParty: 0,
    notificationCreated: false,
    shopFeeBeforeDiscount: true,
    isDemo: false,
    isAssociatedWithStatement: false,
    lockedInvoiceWithStatement: false,
    attachmentCount: 0,
    attachmentSequence: 0,
    isInActive: false,
    _id: '612dfd3bf245242b3cedc440',
    start: '2021-08-31T09:58:18.192Z',
    createdBy: '5f75e92a1d8dd0001760ebd9',
    isOtherTaxable: true,
    code: '11735',
    workFlowDate: '2021-08-31T09:58:19.014Z',
    oldPartsTechQoutes: [],
    appointments: [],
    tags: [],
    inspections: [],
    services: [
      {
        serviceTotal: {
          itemTypeDiscount: {
            part: 0,
            labor: 0,
            tire: 0,
            hazmatFee: 0,
            other: 0,
          },
          part: 83.5,
          labor: 240,
          tire: 0,
          other: 0,
          hazmatFee: 0,
          total: 323.5,
          netTotal: 323.5,
          itemsDiscount: 0,
          taxAmt: 0,
          serviceTaxableAmt: 0,
          serviceNonTaxableAmt: 323.5,
          serviceDiscountAmt: 0,
        },
        totalCost: { part: 83.5, labor: 90, tire: 0, hazmatFee: 0, other: 0 },
        includeInInvoice: true,
        billableHours: 1.2,
        workedHours: 0,
        authorized: false,
        status: 'new',
        saleStatus: 'inprogress',
        serviceType: '',
        itemSource: 'Motor',
        serviceStatus: 'approved',
        isAuthUpdatedByCustomer: false,
        isRecommended: false,
        isTechFlag: false,
        _id: '612dfe761179962decdbf7e4',
        title: 'Brake Line R&R (Both Sides)',
        notes: 'Front',
        items: [
          {
            discount: {
              value: 0,
              cap: 0,
              type: 'percentage',
              name: 'Percent',
            },
            pricing: {
              pricingId: '5fce21113aabdd0017aee5d0',
              name: 'Labor-Motor-200',
            },
            itemSource: 'Motor',
            displayHoursOnOrder: true,
            displayDescOnOrder: false,
            isTaxable: false,
            count: 1.2,
            discountAmt: null,
            taxAmt: 0,
            price: 200,
            netPrice: 200,
            cost: 90,
            costEstimatedHours: 1.2,
            subTotal: 240,
            netSubTotal: 240,
            stocked: false,
            _id: '612dfe761179962decdbf7e5',
            type: 'labor',
            title: 'Brake Line R&R (Both Sides, Front)',
            description:
              'Includes: The removal of component and all necessary components for access. Does not include: Brake Hydraulic System Bleed. System diagnosis and testing, or a vehicle road test.',
            itemSourceId: '232852587',
            qboId: '4',
            tags: [{ name: 'MOTOR', color: '#009cdc' }],
            createdAt: '2021-08-31T10:03:34.478Z',
            itemId: '612dfe761179962decdbf7e5',
            updatedAt: '2021-08-31T10:03:50.194Z',
          },
          {
            discount: {
              value: 0,
              cap: 0,
              type: 'percentage',
              name: 'Percent',
            },
            pricing: {
              pricingId: '5fd747f91b835d0017ac3e08',
              name: 'old price',
            },
            itemSource: 'Motor',
            displayHoursOnOrder: true,
            displayDescOnOrder: true,
            isTaxable: false,
            count: 1,
            discountAmt: null,
            taxAmt: 0,
            price: 23.5,
            netPrice: 23.5,
            cost: 23.5,
            costEstimatedHours: 0,
            subTotal: 23.5,
            netSubTotal: 23.5,
            stocked: false,
            _id: '612dfe761179962decdbf7e6',
            code: '000989080701',
            type: 'part',
            title: 'Brake Fluid Type',
            description: ' Hydraulic Brake Fluid, DOT 4\nUse DOT 4 plus, P/N 000989080701 or products approved on MB Sheet 331.0.',
            itemSourceId: '237317021',
            qboId: '7',
            tags: [{ name: 'MOTOR', color: '#009cdc' }],
            createdAt: '2021-08-31T10:03:34.479Z',
            itemId: '612dfe761179962decdbf7e6',
            updatedAt: '2021-08-31T10:03:50.195Z',
          },
          {
            discount: {
              value: 0,
              cap: 0,
              type: 'percentage',
              name: 'Percent',
            },
            pricing: {
              pricingId: '5fd747f91b835d0017ac3e08',
              name: 'old price',
            },
            itemSource: 'Motor',
            displayHoursOnOrder: true,
            displayDescOnOrder: true,
            isTaxable: false,
            count: 1,
            discountAmt: null,
            taxAmt: 0,
            price: 0,
            netPrice: 0,
            cost: 0,
            costEstimatedHours: 0,
            subTotal: 0,
            netSubTotal: 0,
            stocked: false,
            _id: '612dfe761179962decdbf7e7',
            code: 'NR',
            type: 'part',
            title: 'ABS Pressure Hose',
            description: ' ',
            itemSourceId: '229900339',
            qboId: '7',
            tags: [{ name: 'MOTOR', color: '#009cdc' }],
            createdAt: '2021-08-31T10:03:34.481Z',
            itemId: '612dfe761179962decdbf7e7',
            updatedAt: '2021-08-31T10:03:50.197Z',
          },
          {
            discount: {
              value: 0,
              cap: 0,
              type: 'percentage',
              name: 'Percent',
            },
            pricing: {
              pricingId: '5fd747f91b835d0017ac3e08',
              name: 'old price',
            },
            itemSource: 'Motor',
            displayHoursOnOrder: true,
            displayDescOnOrder: true,
            isTaxable: false,
            count: 2,
            discountAmt: null,
            taxAmt: 0,
            price: 30,
            netPrice: 30,
            cost: 30,
            costEstimatedHours: 0,
            subTotal: 60,
            netSubTotal: 60,
            stocked: false,
            _id: '612dfe761179962decdbf7e8',
            code: '253 420 01 48',
            type: 'part',
            title: 'Brake Hydraulic Hose',
            description: '#253 420 01 48 - Front ',
            itemSourceId: '229914919',
            qboId: '7',
            tags: [{ name: 'MOTOR', color: '#009cdc' }],
            createdAt: '2021-08-31T10:03:34.482Z',
            itemId: '612dfe761179962decdbf7e8',
            updatedAt: '2021-08-31T10:03:50.198Z',
          },
        ],
        itemSourceId: '232852587',
        serviceAuthHistory: [],
        serviceStatusUpdatedAt: '2021-08-31T10:03:47.467Z',
        createdAt: '2021-08-31T10:03:34.484Z',
        updatedAt: '2021-08-31T10:03:34.484Z',
        serviceId: '612dfe761179962decdbf7e4',
      },
      {
        serviceTotal: {
          itemTypeDiscount: {
            part: 0,
            labor: 0,
            tire: 0,
            hazmatFee: 0,
            other: 0,
          },
          part: 9.6,
          labor: 1420,
          tire: 0,
          other: 0,
          hazmatFee: 0,
          total: 1429.6,
          netTotal: 1429.6,
          itemsDiscount: 0,
          taxAmt: 0,
          serviceTaxableAmt: 0,
          serviceNonTaxableAmt: 1429.6,
          serviceDiscountAmt: 0,
        },
        totalCost: {
          part: 8.73,
          labor: 2130,
          tire: 0,
          hazmatFee: 0,
          other: 0,
        },
        includeInInvoice: true,
        billableHours: 7.1,
        workedHours: 0,
        authorized: false,
        status: 'new',
        saleStatus: 'inprogress',
        serviceType: '',
        itemSource: 'Motor',
        serviceStatus: 'approved',
        isAuthUpdatedByCustomer: false,
        isRecommended: false,
        isTechFlag: false,
        _id: '612dfd96f245242b3cedc44f',
        title: 'Air Bag Inflator Module R&R',
        notes: 'Passenger Inflator Module',
        items: [
          {
            discount: {
              value: 0,
              cap: 0,
              type: 'percentage',
              name: 'Percent',
            },
            pricing: {
              pricingId: '5fce21113aabdd0017aee5d0',
              name: 'Labor-Motor-200',
            },
            itemSource: 'Motor',
            displayHoursOnOrder: true,
            displayDescOnOrder: false,
            isTaxable: false,
            count: 7.1,
            discountAmt: null,
            taxAmt: 0,
            price: 200,
            netPrice: 200,
            cost: 2130,
            costEstimatedHours: 7.1,
            subTotal: 1420,
            netSubTotal: 1420,
            stocked: false,
            _id: '612dfd96f245242b3cedc450',
            type: 'labor',
            title: 'Air Bag Inflator Module R&R (Passenger Inflator Module)',
            description:
              'Includes: The removal of component and all necessary components for access. Does not include: System diagnosis, testing, reprogramming, or a vehicle road test. Time for retest system. WARNING: Before repairing any air restraint system. The battery and any back-up power supplies to the system must be disconnected to prevent accidental deployment.',
            itemSourceId: '232897543',
            qboId: '4',
            tags: [{ name: 'MOTOR', color: '#009cdc' }],
            createdAt: '2021-08-31T09:59:50.773Z',
            itemId: '612dfd96f245242b3cedc450',
            updatedAt: '2021-08-31T10:03:50.203Z',
          },
          {
            discount: {
              value: 0,
              cap: 0,
              type: 'percentage',
              name: 'Percent',
            },
            pricing: {
              pricingId: '5fd747f91b835d0017ac3e08',
              name: 'old price',
            },
            itemSource: 'Motor',
            displayHoursOnOrder: true,
            displayDescOnOrder: true,
            isTaxable: false,
            count: 4,
            discountAmt: null,
            taxAmt: 0,
            price: 2.4,
            netPrice: 2.4,
            cost: 2.1818181818181817,
            costEstimatedHours: 0,
            subTotal: 9.6,
            netSubTotal: 9.6,
            stocked: false,
            _id: '612dfd96f245242b3cedc451',
            code: '003 990 53 51',
            type: 'part',
            title: 'Instrument Panel Air Bag Nut',
            description: 'AIR BAGS ',
            itemSourceId: '226763939',
            qboId: '7',
            tags: [{ name: 'MOTOR', color: '#009cdc' }],
            createdAt: '2021-08-31T09:59:50.775Z',
            itemId: '612dfd96f245242b3cedc451',
            updatedAt: '2021-08-31T10:03:50.206Z',
          },
        ],
        itemSourceId: '232897543',
        serviceAuthHistory: [],
        serviceStatusUpdatedAt: '2021-08-31T10:03:47.467Z',
        createdAt: '2021-08-31T10:03:30.612Z',
        updatedAt: '2021-08-31T09:59:50.777Z',
        serviceId: '612dfd96f245242b3cedc44f',
      },
    ],
    techs: [],
    reminders: [],
    attachments: [],
    createdAt: '2021-08-31T09:58:19.052Z',
    updatedAt: '2021-08-31T10:05:51.292Z',
    __v: 0,
    approvedAt: '2021-08-31T10:03:47.468Z',
    authorizedBy: null,
    sendEstimate: '2021-08-31T10:05:15.668Z',
  },
  disclaimer:
    "I hereby authorize the above repair work to be done along with all necessary materials. \n\n\nsales@autoleap.com may operate the above vehicle for the purposes of testing, inspection or delivery at my risk. The shop will not be held responsible for loss or damage to vehicle or articles left in vehicle in case of fire, theft, \naccident or any other cause beyond 's control. \nIn the event legal action is necessary to enforce this contract, I understand that I am solely responsible for all costs including",
  invDisclaimer:
    "I hereby authorize the above repair work to be done along with all necessary sales@autoleap.com\n\n may operate the above vehicle for the purposes of testing, inspection or delivery at my risk. The shop will not be held responsible for loss or damage to vehicle or articles left in vehicle in case of fire, \ntheft, accident or any other cause beyond 's control.In the event legal action is necessary to enforce this contract, \nI understand that I am solely responsible for all costs including",
};
